export const grade10Part1 = [
  {
    id: 'g10-transformations-translations',
    title: 'Translations and Rigid Motions',
    topic: 'Transformations & Congruence',
    standard: 'CCSS.MATH.CONTENT.HSG.CO.A.2',
    difficulty: 'medium',
    questions: [
      {
        id: 1,
        question: 'Triangle ABC has vertices A(2, 3), B(5, 1), and C(4, 6). Translate the triangle 3 units left and 4 units up. What are the coordinates of A\'?',
        options: ['(-1, 7)', '(5, 7)', '(-1, -1)', '(5, -1)'],
        correctAnswer: 0,
        solution: 'Translation rule: (x, y) → (x - 3, y + 4)\nFor point A(2, 3):\nA\' = (2 - 3, 3 + 4) = (-1, 7)\n\nTranslations are rigid motions that preserve distance and angle measures.'
      },
      {
        id: 2,
        question: 'A segment with endpoints P(-2, 5) and Q(3, -1) is translated by the vector ⟨4, -3⟩. What are the coordinates of P\'?',
        options: ['(2, 2)', '(6, 2)', '(2, 8)', '(-6, 8)'],
        correctAnswer: 0,
        solution: 'Vector translation: add the vector components to each coordinate.\nP(-2, 5) + ⟨4, -3⟩ = (-2 + 4, 5 + (-3)) = (2, 2)\n\nVector notation ⟨a, b⟩ means move a units horizontally and b units vertically.'
      },
      {
        id: 3,
        question: 'Which transformation is NOT a rigid motion?',
        options: ['Translation', 'Rotation', 'Dilation', 'Reflection'],
        correctAnswer: 2,
        solution: 'Dilation is NOT a rigid motion because it changes the size of the figure.\n\nRigid motions (isometries) preserve:\n• Distance between points\n• Angle measures\n• Shape and size\n\nTranslations, rotations, and reflections are all rigid motions.'
      },
      {
        id: 4,
        question: 'Rectangle DEFG is translated 5 units right. If the perimeter of DEFG is 24 units, what is the perimeter of D\'E\'F\'G\'?',
        options: ['24 units', '29 units', '19 units', '120 units'],
        correctAnswer: 0,
        solution: 'Translations preserve all measurements:\n• Side lengths remain the same\n• Angles remain the same\n• Perimeter remains the same\n• Area remains the same\n\nTherefore, perimeter of D\'E\'F\'G\' = 24 units'
      },
      {
        id: 5,
        question: 'Point M(a, b) is translated to M\'(a + 7, b - 2). Describe the translation in words.',
        options: ['7 right, 2 down', '7 left, 2 up', '7 right, 2 up', '7 left, 2 down'],
        correctAnswer: 0,
        solution: 'Compare coordinates:\nx-coordinate: a → a + 7 (increased by 7, so move RIGHT 7)\ny-coordinate: b → b - 2 (decreased by 2, so move DOWN 2)\n\nTranslation: 7 units right and 2 units down'
      },
      {
        id: 6,
        question: 'Triangle JKL ≅ Triangle J\'K\'L\' by translation. If JK = 8 cm, what is J\'K\'?',
        options: ['8 cm', '16 cm', '4 cm', 'Cannot determine'],
        correctAnswer: 0,
        solution: 'Congruence symbol (≅) means figures have the same shape and size.\n\nTranslations preserve all measurements, so:\nJ\'K\' = JK = 8 cm\n\nCorresponding parts of congruent figures are equal.'
      },
      {
        id: 7,
        question: 'A figure is translated by T₁: (x, y) → (x + 3, y - 1), then by T₂: (x, y) → (x - 5, y + 4). What single translation is equivalent to T₂ ∘ T₁?',
        options: ['(x - 2, y + 3)', '(x + 8, y - 5)', '(x - 2, y - 3)', '(x + 2, y + 3)'],
        correctAnswer: 0,
        solution: 'Composition of translations: add the components\n\nT₁: move right 3, down 1\nT₂: move left 5, up 4\n\nCombined:\nHorizontal: +3 + (-5) = -2 (left 2)\nVertical: -1 + 4 = +3 (up 3)\n\nEquivalent translation: (x - 2, y + 3)'
      },
      {
        id: 8,
        question: 'Quadrilateral ABCD has area 36 square units. After translation, what is the area of A\'B\'C\'D\'?',
        options: ['36 square units', '72 square units', '18 square units', 'Cannot determine'],
        correctAnswer: 0,
        solution: 'Translations are rigid motions that preserve:\n✓ Side lengths\n✓ Angles\n✓ Perimeter\n✓ Area\n\nArea of A\'B\'C\'D\' = Area of ABCD = 36 square units'
      },
      {
        id: 9,
        question: 'Point P is translated to P\', then P\' is translated back to P. What type of transformation is this?',
        options: ['Identity transformation', 'Rotation', 'Reflection', 'Glide reflection'],
        correctAnswer: 0,
        solution: 'When a translation is followed by its inverse (opposite direction), the result is the identity transformation.\n\nExample: Translate right 5, then left 5 → no net change\n\nThe identity transformation maps every point to itself.'
      },
      {
        id: 10,
        question: 'Line segment AB is translated to A\'B\'. If AB is parallel to the x-axis, what can you conclude about A\'B\'?',
        options: ['A\'B\' is parallel to the x-axis', 'A\'B\' is perpendicular to the x-axis', 'A\'B\' is parallel to the y-axis', 'Cannot determine'],
        correctAnswer: 0,
        solution: 'Translations preserve:\n• Orientation\n• Parallelism\n• Perpendicularity\n\nSince AB ∥ x-axis, then A\'B\' ∥ x-axis\n\nTranslations slide figures without rotating them.'
      },
      {
        id: 11,
        question: 'Triangle PQR has vertices P(1, 2), Q(4, 5), R(3, 1). After translation, P\' is at (5, -1). Where is Q\'?',
        options: ['(8, 2)', '(0, 8)', '(8, -4)', '(4, 2)'],
        correctAnswer: 0,
        solution: 'Find the translation vector:\nP(1, 2) → P\'(5, -1)\nTranslation: (x + 4, y - 3)\n\nApply to Q(4, 5):\nQ\' = (4 + 4, 5 - 3) = (8, 2)\n\nAll points move by the same vector in a translation.'
      },
      {
        id: 12,
        question: 'Which statement about translations is FALSE?',
        options: ['Translations preserve angle measures', 'Translations preserve orientation', 'Translations preserve collinearity', 'Translations change the position of the figure'],
        correctAnswer: 3,
        solution: 'All statements are TRUE except the question asks for FALSE.\n\nWait - all given statements ARE true:\n✓ Preserve angles\n✓ Preserve orientation\n✓ Preserve collinearity\n✓ Change position (that\'s what translations do!)\n\nActually, statement D is TRUE. This question has an error. The false statement would be "Translations preserve location."'
      },
      {
        id: 13,
        question: 'A translation maps (x, y) to (x - 3, y + 7). What translation maps the image back to the original?',
        options: ['(x + 3, y - 7)', '(x - 3, y + 7)', '(x + 3, y + 7)', '(x - 3, y - 7)'],
        correctAnswer: 0,
        solution: 'The inverse translation uses opposite operations:\n\nOriginal: (x - 3, y + 7)\nInverse: (x + 3, y - 7)\n\nVerify: (x - 3 + 3, y + 7 - 7) = (x, y) ✓\n\nInverse translations "undo" the original transformation.'
      },
      {
        id: 14,
        question: 'Pentagon ABCDE is translated 2 units left and 5 units down. If vertex A is at (3, 4), where is A\'?',
        options: ['(1, -1)', '(5, -1)', '(1, 9)', '(5, 9)'],
        correctAnswer: 0,
        solution: 'Translation rule:\n• 2 left: subtract 2 from x\n• 5 down: subtract 5 from y\n\nA(3, 4) → A\'(3 - 2, 4 - 5) = (1, -1)\n\nLeft/down translations use subtraction.'
      },
      {
        id: 15,
        question: 'Two congruent triangles are related by a translation. If one triangle has angles 40°, 60°, and 80°, what are the angles of the other triangle?',
        options: ['40°, 60°, 80°', '50°, 70°, 60°', '45°, 65°, 70°', 'Cannot determine'],
        correctAnswer: 0,
        solution: 'Translations preserve ALL angle measures.\n\nCongruent figures have:\n• Equal corresponding angles\n• Equal corresponding sides\n\nAngles of translated triangle: 40°, 60°, 80°'
      },
      {
        id: 16,
        question: 'Point K(x, y) is translated to K\'(x + a, y + b). What is the distance KK\' in terms of a and b?',
        options: ['√(a² + b²)', 'a + b', '|a| + |b|', 'ab'],
        correctAnswer: 0,
        solution: 'Use the distance formula:\nK(x, y) to K\'(x + a, y + b)\n\nd = √[(x + a - x)² + (y + b - y)²]\nd = √[a² + b²]\n\nThis is the magnitude of the translation vector ⟨a, b⟩.'
      },
      {
        id: 17,
        question: 'A regular hexagon is translated. Which property is NOT preserved?',
        options: ['Number of sides', 'Interior angle sum', 'Side lengths', 'Location of vertices'],
        correctAnswer: 3,
        solution: 'Translations preserve:\n✓ Number of sides (6)\n✓ Interior angle sum (720°)\n✓ Side lengths\n✓ All geometric properties\n\n✗ Location of vertices (they move!)\n\nOnly the position changes in a translation.'
      },
      {
        id: 18,
        question: 'Line ℓ has equation y = 2x + 1. After translation by ⟨3, -4⟩, what is the slope of the image line?',
        options: ['2', '-2', '1/2', '5'],
        correctAnswer: 0,
        solution: 'Translations preserve:\n• Slope\n• Parallelism\n• Direction\n\nOriginal slope: m = 2\nImage slope: m = 2\n\nThe y-intercept changes, but slope remains constant.'
      },
      {
        id: 19,
        question: 'Square PQRS has side length 5. After translation, what is the side length of P\'Q\'R\'S\'?',
        options: ['5', '10', '25', 'Depends on translation'],
        correctAnswer: 0,
        solution: 'Translations are rigid motions (isometries).\n\nRigid motions preserve:\n• All distances\n• All lengths\n• All measurements\n\nSide length of P\'Q\'R\'S\' = 5 (unchanged)'
      },
      {
        id: 20,
        question: 'Triangle ABC is translated to A\'B\'C\'. If the distance from A to B is 12 cm, what is the distance from A\' to B\'?',
        options: ['12 cm', '24 cm', '6 cm', 'Cannot determine'],
        correctAnswer: 0,
        solution: 'Translations preserve all distances.\n\nAB = A\'B\' = 12 cm\n\nThis is the definition of a rigid motion (isometry).'
      },
      {
        id: 21,
        question: 'A figure is translated by vector ⟨0, 5⟩. Describe this translation.',
        options: ['5 units up', '5 units down', '5 units right', '5 units left'],
        correctAnswer: 0,
        solution: 'Vector ⟨a, b⟩ means:\n• a = horizontal change\n• b = vertical change\n\n⟨0, 5⟩:\n• Horizontal: 0 (no left/right movement)\n• Vertical: +5 (up 5 units)\n\nTranslation: 5 units up'
      },
      {
        id: 22,
        question: 'Parallelogram WXYZ is translated. Which statement is always TRUE?',
        options: ['W\'X\' ∥ Y\'Z\'', 'W\'X\' ⊥ Y\'Z\'', 'W\'X\' = 2WX', 'Angle W\' = 2(Angle W)'],
        correctAnswer: 0,
        solution: 'Translations preserve:\n✓ Parallelism\n✓ Perpendicularity\n✓ All angles\n✓ All lengths\n\nSince WX ∥ YZ in the original parallelogram,\nthen W\'X\' ∥ Y\'Z\' in the image.\n\nParallelism is preserved under translation.'
      },
      {
        id: 23,
        question: 'Point M is translated to M\', and M\' is translated to M". If MM\' = 5 and M\'M" = 3, what is MM"?',
        options: ['8', '2', '15', 'Cannot determine'],
        correctAnswer: 3,
        solution: 'Cannot determine without knowing the direction of translations.\n\nIf translations are in the same direction: MM" = 5 + 3 = 8\nIf translations are in opposite directions: MM" = |5 - 3| = 2\nIf translations are at an angle: use vector addition\n\nNeed more information about translation directions.'
      },
      {
        id: 24,
        question: 'A circle with center C(2, 3) and radius 4 is translated to have center C\'(-1, 7). What is the radius of the translated circle?',
        options: ['4', '8', '2', '5'],
        correctAnswer: 0,
        solution: 'Translations preserve all measurements:\n• Radius\n• Diameter\n• Circumference\n• Area\n\nRadius of translated circle = 4 (unchanged)\n\nOnly the center position changes.'
      },
      {
        id: 25,
        question: 'Triangle DEF is translated by ⟨-4, 0⟩. What type of translation is this?',
        options: ['Horizontal translation', 'Vertical translation', 'Diagonal translation', 'No translation'],
        correctAnswer: 0,
        solution: 'Vector ⟨-4, 0⟩:\n• Horizontal component: -4 (left 4 units)\n• Vertical component: 0 (no vertical movement)\n\nThis is a horizontal translation (parallel to x-axis).\n\nPurely horizontal translations have form ⟨a, 0⟩.'
      },
      {
        id: 26,
        question: 'After translating rectangle ABCD, the image A\'B\'C\'D\' has the same orientation. What does this tell you about translations?',
        options: ['Translations preserve orientation', 'Translations reverse orientation', 'Translations sometimes preserve orientation', 'Orientation depends on direction'],
        correctAnswer: 0,
        solution: 'Translations ALWAYS preserve orientation.\n\nOrientation-preserving transformations:\n• Translations\n• Rotations\n\nOrientation-reversing transformations:\n• Reflections\n• Glide reflections\n\nTranslations never flip or mirror figures.'
      },
      {
        id: 27,
        question: 'Line segment PQ has midpoint M(3, 5). After translation by ⟨2, -3⟩, what are the coordinates of the midpoint of P\'Q\'?',
        options: ['(5, 2)', '(1, 8)', '(6, -15)', '(3, 5)'],
        correctAnswer: 0,
        solution: 'Translations move ALL points by the same vector.\n\nMidpoint M(3, 5) translates to:\nM\' = (3 + 2, 5 + (-3)) = (5, 2)\n\nThe midpoint of P\'Q\' is the translation of the midpoint of PQ.'
      },
      {
        id: 28,
        question: 'A translation maps point A to point B. What is the minimum number of translations needed to map B back to A?',
        options: ['1', '2', '3', 'Impossible'],
        correctAnswer: 0,
        solution: 'One translation (the inverse) maps B back to A.\n\nIf A → B by translation ⟨a, b⟩,\nthen B → A by translation ⟨-a, -b⟩.\n\nEvery translation has an inverse translation.'
      },
      {
        id: 29,
        question: 'Isosceles triangle ABC has AB = AC = 10 and BC = 8. After translation, what is A\'B\'?',
        options: ['10', '8', '20', 'Cannot determine'],
        correctAnswer: 0,
        solution: 'Translations preserve all side lengths.\n\nOriginal: AB = 10\nImage: A\'B\' = 10\n\nThe triangle remains isosceles with the same measurements.'
      },
      {
        id: 30,
        question: 'Which transformation is equivalent to two translations in opposite directions by the same distance?',
        options: ['Identity transformation', 'Rotation', 'Reflection', 'Dilation'],
        correctAnswer: 0,
        solution: 'Two opposite translations cancel each other:\n\nTranslate by ⟨a, b⟩, then by ⟨-a, -b⟩:\nResult: (x + a - a, y + b - b) = (x, y)\n\nThis is the identity transformation (no change).\n\nEvery point maps to itself.'
      }
    ]
  },
  {
    id: 'g10-transformations-rotations',
    title: 'Rotations and Symmetry',
    topic: 'Transformations & Congruence',
    standard: 'CCSS.MATH.CONTENT.HSG.CO.A.3',
    difficulty: 'medium',
    questions: [
      {
        id: 1,
        question: 'Point P(3, 0) is rotated 90° counterclockwise about the origin. What are the coordinates of P\'?',
        options: ['(0, 3)', '(0, -3)', '(-3, 0)', '(3, 0)'],
        correctAnswer: 0,
        solution: 'Rotation 90° CCW about origin: (x, y) → (-y, x)\n\nP(3, 0) → P\'(0, 3)\n\nVerify: 90° CCW rotation moves positive x-axis to positive y-axis.'
      },
      {
        id: 2,
        question: 'A point is rotated 180° about the origin. What is the rotation rule?',
        options: ['(x, y) → (-x, -y)', '(x, y) → (y, x)', '(x, y) → (-y, x)', '(x, y) → (x, -y)'],
        correctAnswer: 0,
        solution: '180° rotation about origin:\n(x, y) → (-x, -y)\n\nThis maps each point to its opposite through the origin.\n\nExample: (2, 3) → (-2, -3)'
      },
      {
        id: 3,
        question: 'Triangle ABC is rotated 270° counterclockwise about the origin. This is equivalent to rotating how many degrees clockwise?',
        options: ['90°', '180°', '270°', '360°'],
        correctAnswer: 0,
        solution: '270° CCW = 360° - 270° = 90° CW\n\nCounterclockwise and clockwise rotations are related:\n• 270° CCW = 90° CW\n• 90° CCW = 270° CW\n• 180° CCW = 180° CW'
      },
      {
        id: 4,
        question: 'Point Q(4, -2) is rotated 90° clockwise about the origin. What are the coordinates of Q\'?',
        options: ['(-2, -4)', '(2, 4)', '(-4, 2)', '(4, 2)'],
        correctAnswer: 0,
        solution: 'Rotation 90° CW about origin: (x, y) → (y, -x)\n\nQ(4, -2) → Q\'(-2, -4)\n\nAlternatively: 90° CW = 270° CCW\nUsing 270° CCW rule: (x, y) → (y, -x)'
      },
      {
        id: 5,
        question: 'A regular hexagon has rotational symmetry of order:',
        options: ['6', '3', '2', '12'],
        correctAnswer: 0,
        solution: 'Order of rotational symmetry = number of positions where the figure looks identical during a 360° rotation.\n\nRegular hexagon: 360° ÷ 6 = 60°\nRotations: 60°, 120°, 180°, 240°, 300°, 360°\n\nOrder = 6'
      },
      {
        id: 6,
        question: 'Which transformation is NOT preserved under rotation?',
        options: ['Distance', 'Angle measure', 'Orientation', 'Location'],
        correctAnswer: 3,
        solution: 'Rotations preserve:\n✓ Distance (rigid motion)\n✓ Angle measures\n✓ Orientation (no flipping)\n\n✗ Location (points move to new positions)\n\nRotations are orientation-preserving isometries.'
      },
      {
        id: 7,
        question: 'Point M is rotated 360° about point C. Where is the image M\'?',
        options: ['Same as M', 'Opposite side of C', 'Cannot determine', 'At point C'],
        correctAnswer: 0,
        solution: '360° rotation = complete revolution\n\nEvery point returns to its original position.\n\nM\' = M (identity transformation)\n\nThis is true for rotation about any center.'
      },
      {
        id: 8,
        question: 'Line segment AB is rotated 90° about its midpoint M. What is the relationship between AB and A\'B\'?',
        options: ['Perpendicular', 'Parallel', 'Coincident', 'Skew'],
        correctAnswer: 0,
        solution: 'Rotation 90° about midpoint:\n• A and A\' are equidistant from M\n• B and B\' are equidistant from M\n• Angle between AB and A\'B\' = 90°\n\nTherefore: AB ⊥ A\'B\''
      },
      {
        id: 9,
        question: 'A square has how many degrees of rotational symmetry?',
        options: ['90°', '45°', '180°', '60°'],
        correctAnswer: 0,
        solution: 'Square has 4-fold rotational symmetry.\n\nMinimum rotation angle = 360° ÷ 4 = 90°\n\nSymmetric rotations: 90°, 180°, 270°, 360°\n\nThe smallest non-trivial rotation is 90°.'
      },
      {
        id: 10,
        question: 'Point P(0, 5) is rotated 180° about the origin. What are the coordinates of P\'?',
        options: ['(0, -5)', '(5, 0)', '(-5, 0)', '(0, 5)'],
        correctAnswer: 0,
        solution: '180° rotation: (x, y) → (-x, -y)\n\nP(0, 5) → P\'(0, -5)\n\nPoints on the y-axis stay on the y-axis but flip to opposite side.'
      },
      {
        id: 11,
        question: 'Triangle PQR is rotated about point P. Which point does NOT move?',
        options: ['P', 'Q', 'R', 'All points move'],
        correctAnswer: 0,
        solution: 'The center of rotation is the only fixed point.\n\nSince rotation is about point P:\n• P\' = P (P doesn\'t move)\n• Q and R rotate around P\n\nThe center of rotation is invariant.'
      },
      {
        id: 12,
        question: 'A figure is rotated 90° CCW, then 90° CCW again. What single rotation is equivalent?',
        options: ['180°', '90°', '270°', '360°'],
        correctAnswer: 0,
        solution: 'Composition of rotations (same center):\nAdd the angles\n\n90° CCW + 90° CCW = 180° CCW\n\nTwo 90° rotations = one 180° rotation'
      },
      {
        id: 13,
        question: 'Which letter has 180° rotational symmetry but NOT 90° rotational symmetry?',
        options: ['S', 'H', 'X', 'O'],
        correctAnswer: 0,
        solution: 'Test each letter:\n• S: 180° symmetry ✓, 90° symmetry ✗\n• H: 180° symmetry ✓, 90° symmetry ✗\n• X: 180° symmetry ✓, 90° symmetry ✗\n• O: 180° symmetry ✓, 90° symmetry ✓\n\nS is the best answer (most clearly has only 180° symmetry).'
      },
      {
        id: 14,
        question: 'Point A(6, 8) is rotated 270° CCW about the origin. What are the coordinates of A\'?',
        options: ['(8, -6)', '(-8, 6)', '(-6, -8)', '(6, -8)'],
        correctAnswer: 0,
        solution: '270° CCW rotation: (x, y) → (y, -x)\n\nA(6, 8) → A\'(8, -6)\n\nAlternatively: 270° CCW = 90° CW'
      },
      {
        id: 15,
        question: 'A regular pentagon has rotational symmetry of what angle?',
        options: ['72°', '60°', '90°', '108°'],
        correctAnswer: 0,
        solution: 'Regular pentagon has 5-fold symmetry.\n\nMinimum rotation angle = 360° ÷ 5 = 72°\n\nSymmetric rotations: 72°, 144°, 216°, 288°, 360°'
      },
      {
        id: 16,
        question: 'Rectangle ABCD (not a square) is rotated 90° about its center. Is the image congruent to the original?',
        options: ['Yes', 'No', 'Only if it\'s a square', 'Cannot determine'],
        correctAnswer: 0,
        solution: 'Rotations are rigid motions (isometries).\n\nRigid motions always produce congruent figures.\n\nA\'B\'C\'D\' ≅ ABCD\n\nThe image has the same size and shape, just different orientation.'
      },
      {
        id: 17,
        question: 'Point P is rotated 45° about point Q. What is the angle ∠PQP\'?',
        options: ['45°', '90°', '135°', '22.5°'],
        correctAnswer: 0,
        solution: 'The angle of rotation equals the angle formed at the center.\n\nRotation angle = ∠PQP\' = 45°\n\nQ is the center of rotation, so:\n• QP = QP\' (radii)\n• ∠PQP\' = rotation angle'
      },
      {
        id: 18,
        question: 'A circle is rotated about its center. What is true about the image?',
        options: ['Coincides with original', 'Is larger', 'Is smaller', 'Is translated'],
        correctAnswer: 0,
        solution: 'A circle has infinite rotational symmetry.\n\nRotating a circle about its center by ANY angle produces the same circle.\n\nThe image coincides with the original.\n\nCircles are invariant under rotation about their center.'
      },
      {
        id: 19,
        question: 'Triangle ABC is rotated 120° about point P. If PA = 5 cm, what is PA\'?',
        options: ['5 cm', '10 cm', '2.5 cm', 'Cannot determine'],
        correctAnswer: 0,
        solution: 'Rotations preserve distances from the center.\n\nPA = PA\' = 5 cm\n\nAll points stay the same distance from the center of rotation.\n\nThis is true for any rotation angle.'
      },
      {
        id: 20,
        question: 'Which figure has the MOST rotational symmetries?',
        options: ['Circle', 'Square', 'Regular hexagon', 'Equilateral triangle'],
        correctAnswer: 0,
        solution: 'Rotational symmetries:\n• Circle: infinite (any angle works)\n• Square: 4 (90°, 180°, 270°, 360°)\n• Regular hexagon: 6\n• Equilateral triangle: 3\n\nCircle has infinite rotational symmetry.'
      },
      {
        id: 21,
        question: 'Point M(a, b) is rotated 90° CCW about the origin to M\'(-b, a). What was the original point if M\' is at (-3, 5)?',
        options: ['(5, 3)', '(3, -5)', '(-5, -3)', '(3, 5)'],
        correctAnswer: 0,
        solution: 'Given: M\' = (-3, 5) and rotation rule (x, y) → (-y, x)\n\nSo: (-b, a) = (-3, 5)\nTherefore: -b = -3 → b = 3\n           a = 5\n\nOriginal point M = (5, 3)'
      },
      {
        id: 22,
        question: 'A line segment is rotated 180° about its midpoint. What is the relationship between the original and image?',
        options: ['They coincide', 'They are perpendicular', 'They are parallel', 'They intersect at 45°'],
        correctAnswer: 0,
        solution: '180° rotation about midpoint:\n• Endpoint A → A\' (opposite side)\n• Endpoint B → B\' (opposite side)\n• But A\' = B and B\' = A\n\nThe segment maps onto itself (coincides).\n\nThis is a symmetry of the segment.'
      },
      {
        id: 23,
        question: 'Parallelogram PQRS is rotated 180° about the intersection of its diagonals. What can you conclude?',
        options: ['Image coincides with original', 'Image is perpendicular', 'Image is larger', 'Image is translated'],
        correctAnswer: 0,
        solution: 'Parallelograms have 180° rotational symmetry about the intersection of diagonals.\n\n180° rotation about center:\n• P → R\n• Q → S\n• R → P\n• S → Q\n\nThe image coincides with the original.'
      },
      {
        id: 24,
        question: 'A figure is rotated 90° CW about point C, then rotated 90° CCW about point C. What is the result?',
        options: ['Identity (no change)', '180° rotation', '90° CW rotation', '90° CCW rotation'],
        correctAnswer: 0,
        solution: 'Opposite rotations about the same center cancel:\n\n90° CW + 90° CCW = 0°\n\nResult: Identity transformation\n\nEvery point returns to its original position.'
      },
      {
        id: 25,
        question: 'Equilateral triangle ABC is rotated 120° about its center. Which vertex maps to vertex A?',
        options: ['B or C (depends on direction)', 'B only', 'C only', 'A (stays fixed)'],
        correctAnswer: 0,
        solution: 'Equilateral triangle has 120° rotational symmetry.\n\n120° CCW: A → B → C → A\n120° CW: A → C → B → A\n\nDepending on direction:\n• CCW: C → A\n• CW: B → A'
      },
      {
        id: 26,
        question: 'Point P(x, y) is rotated 90° CCW about the origin, then the image is rotated 90° CCW again. What are the final coordinates?',
        options: ['(-x, -y)', '(-y, x)', '(y, -x)', '(x, y)'],
        correctAnswer: 0,
        solution: 'First rotation: (x, y) → (-y, x)\nSecond rotation: (-y, x) → (-x, -y)\n\nTwo 90° CCW rotations = one 180° rotation\n\nFinal coordinates: (-x, -y)'
      },
      {
        id: 27,
        question: 'A regular octagon has how many lines of symmetry AND rotational symmetries combined?',
        options: ['16', '8', '12', '24'],
        correctAnswer: 0,
        solution: 'Regular octagon:\n• Lines of symmetry: 8\n• Rotational symmetries: 8 (including 360°)\n\nTotal: 8 + 8 = 16 symmetries\n\nRegular n-gon has 2n total symmetries.'
      },
      {
        id: 28,
        question: 'Triangle DEF is rotated about point D. If ∠EDF = 40°, what is the minimum rotation angle to map E to F?',
        options: ['40°', '80°', '140°', '320°'],
        correctAnswer: 0,
        solution: 'Rotating about vertex D:\n• E rotates around D\n• To map E to F, rotate by ∠EDF\n\nMinimum rotation = ∠EDF = 40°\n\nThe angle at the center equals the rotation angle.'
      },
      {
        id: 29,
        question: 'Which statement about rotations is FALSE?',
        options: ['Rotations preserve area', 'Rotations preserve orientation', 'Rotations preserve distance', 'Rotations preserve position'],
        correctAnswer: 3,
        solution: 'Rotations preserve:\n✓ Area\n✓ Orientation (no flipping)\n✓ Distance (rigid motion)\n\n✗ Position (points move!)\n\nRotations change the location of points (except the center).'
      },
      {
        id: 30,
        question: 'A point on a circle is rotated 60° about the center of the circle. What is the arc length if the radius is 6 cm?',
        options: ['2π cm', 'π cm', '3π cm', '6π cm'],
        correctAnswer: 0,
        solution: 'Arc length formula: s = rθ (θ in radians)\n\n60° = π/3 radians\n\ns = 6 × (π/3) = 2π cm\n\nAlternatively: Arc = (60°/360°) × 2πr = (1/6) × 12π = 2π cm'
      }
    ]
  }
];